var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('originator-rules',{ref:"originatorRule",attrs:{"transport":_vm.callTransport}})}
var staticRenderFns = []

export { render, staticRenderFns }